export default {
  head: {
    ClientAdmin: 'Merchant Management',
    ClientLIst: 'merchant list'
  },
  table: {
    addClient: 'add merchant',
    agentAccount: 'agent account',
    GeneralAgent: 'general agent',
    merchantModel: 'merchant model',
    merchantName: 'merchant name',
    merchantPhone: 'phone number',
    merchantNo: 'merchanr account',
    merchantResources: 'merchant resource',
    merchantType: 'merchant type',
    merchantStatus: 'merchant status',
    operaTion: 'operate',
    changemessage: 'edit merchant info',
    checkmessage: 'check merchant infomation',
    payoutQueryUrl: 'Payment reverse check address',
    payoutQueryStatus: 'Payment status check',
    merchantEmail: 'merchant email'
  },
  addDialog: {
    addmerchant: 'Add merchant',
    userPass: 'Login password',
    payPass: 'Payment Key',
    googleCode: 'Google Key',
    googleQrCode: 'QR Google',
    phone: 'phone number',
    optionModtext1: 'customer pay fee',
    optionModtext2: 'merchant pay fee',
    optionRestext1: 'our provide',
    optionRestext2: 'Merchants provide',
    optionTypetext1: 'General agent',
    optionTypetext2: 'agent',
    optionTypetext3: 'merchant',
    optionTypetext4: 'Merchant sub-account',
    optionTypetext5: 'Company Administrator',
    optionWithdratext1: 'Percentage of each withdrawal amount',
    optionWithdratext2: 'Fixed deduction for each transaction',
    placeholdertext: 'Please enter content',
    placeholderName: 'Please enter the merchant name',
    selectModel: 'Choose merchant model',
    selectResour: 'Choose merchant resources',
    selectType: 'Choose merchant type',
    payoutType: 'Merchant payout type',
    normalPayout: 'Normal',
    specialPayout: 'Special',
    orderPrefix: 'Merchant Order Prefix',
    payoutCheckType: 'payout Check Type',
    payoutCheckService: 'payout Check Service'
  },
  updataDia: {
    updatamerchantModel: 'modify merchant model',
    updatamerchantResources: 'modify merchant resources',
    updatamerchantType: 'modify merchant type',
    updatamerchantWithdrawalType: 'modify withdraw fee',
    wallet: 'wallet type',
    card: 'telcos fee',
    merchantWithdrawalFee: 'withdraw fee value',
    merchantWithdrawalType: ' withdraw fee',
    momo: ' momo fee',
    momoIpay: '  momo business fee',
    onlineBankingDirectConnect: 'Bank transfer fee',
    onlineBankingQr: 'bank qr fee',
    payOnBehalfOf: 'payout fee',
    viettelpay: ' viettelpay fee',
    zalo: ' zalopay fee',
    vipQr: 'QRPro Fee',
    usdt: 'USDT Fee',
    checkName: 'Merchant name cannot be empty！',
    universal: 'Universal code handling fee',
    bankTransfer: 'Online banking card transfer fee',
    payoutFixedFee: 'Fixed payment fee',
    momoBank: 'MomoBank Fees',
    zaloBank: 'zaloBank Fees',
    vtpBank: 'vtpBank Fees'
  },

  label: {
    card: 'Recharge card fee',
    merchantWithdrawalFee: 'Withdraw fee',
    momo: 'User fee Momo',
    momoIpay: 'Merchant fee Momo',
    onlineBankingDirectConnect: 'Bank transfer fee',
    onlineBankingQr: 'Bank QR fee',
    payOnBehalfOf: 'Payout fee',
    viettelpay: 'Viettel fee',
    zalo: 'ZALO fee',
    usdt: 'USDT fee',
    vipQr: 'QRPro Fee',
    bankTransfer: 'Online banking card transfer fee',
    payoutFixedFee: 'Pay fixed fee',
    momoBank: 'MomoBank Fees',
    zaloBank: 'zaloBank Fees',
    vtpBank: 'vtpBank Fees',
    balanceMinSafetyAmount: 'Balance minimum warning limit',
    balanceWarningGroupId: 'Balance warning group id',
    notificationName: 'Notify person'
  },

  placeholder: {
    card: 'Enter recharge card fee',
    merchantWithdrawalFee: 'Enter withdraw fee',
    momo: 'Enter user fee Momo',
    momoIpay: 'Enter merchant fee Momo',
    onlineBankingDirectConnect: 'Enter online bank fee',
    onlineBankingQr: 'Enter bank QR fee',
    payOnBehalfOf: 'Enter payout fee',
    viettelpay: 'Enter viettel fee',
    zalo: 'Enter ZALO fee',
    usdt: 'Enter USDT fee',
    vipQr: 'Enter QRPro Fee',
    bankTransfer: 'Please enter the online banking card transfer fee',
    payoutFixedFee: 'Please enter the fixed handling fee',
    momoBank: 'Please enter momoBank fee',
    zaloBank: 'Please enter zaloBank fee',
    vtpBank: 'Please enter vtpBank fee'
  },

  rules: {
    payoutQueryStatus: {
      required: 'Payment query status must be selected'
    },
    merchantType: {
      required: 'Merchant type must be selected'
    },
    agentAcct: {
      required: 'AgentNo must be selected'
    },
    merchantModel: {
      required: 'Merchant model must be selected'
    },
    merchantResources: {
      required: 'Merchant resources must be selected'
    },
    merchantWithdrawalType: {
      required: 'Merchant withdrawal fee must be selected'
    },
    payPass: {
      required: 'Payment password cannot be empty',
      between: 'Payment password must be greater than 6 digits and less than or equal to 20 digits'
    },
    card: {
      required: 'recharge card fee can not be empty',
      type: 'recharge card fee must be a number',
      min: 'recharge card fee must be greater than 0',
      max: 'The recharge card fee must be less than or equal to 100',

      float: 'recharge card fee can have up to two decimal places'
    },
    merchantWithdrawalFee: {
      required: 'withdrawal fee can not be empty',
      type: 'withdrawal feemust be a number',
      min: 'The required withdrawal fee must be greater than 0',

      max: 'The withdrawal fee must be less than or equal to 100',

      float: 'withdrawal fee can have up to two decimal places'
    },
    momo: {
      required: 'momo personal fee can not be empty',
      type: 'momo personal fee must be a number',
      min: 'momo personal fee must be greater than 0',

      max: 'momo personal fee must be less than or equal to',

      float: 'momo personal fee can have up to two decimal places'
    },
    momoIpay: {
      required: 'Momo merchant fee can not be empty',
      type: 'Momo merchant fee must be a number',
      min: 'Momo merchant fee must be greater than 0',

      max: 'Momo merchant fee must be less than or equal to 100',

      float: 'Momo merchant fee can have up to two decimal places'
    },
    onlineBankingDirectConnect: {
      required: 'Online banking fee can not be empty',
      type: 'Online banking fee must be a number',
      min: 'Online banking fee must be greater than 0',

      max: 'Online banking fee must be less than or equal to 100',

      float: 'Online banking fee can have up to two decimal places'
    },
    qrPro: {
      required: 'qrPro individual processing fee cannot be empty',
      type: 'qrPro individual processing fee must be a number',
      min: 'qrPro individual processing fee must be greater than 0',
      max: 'qrPro individual processing fee must be less than or equal to 100',
      float: 'qrPro individual processing fees can have a maximum of two decimal places.'
    },
    onlineBankingQr: {
      required: 'Bank QR can not be empty',
      type: 'Bank QR must be a number',
      min: 'Bank QR must be greater than 0',

      max: 'Bank QR fee must be less than or equal to 100',

      float: 'Bank QR can have up to two decimal places'
    },
    payOnBehalfOf: {
      required: 'payout fee can not be empty',
      type: 'payout fee must be a number',
      min: 'payout fee must be greater than 0',

      max: 'payout fee must be less than or equal to 100',

      float: 'payout fee can have up to two decimal places'
    },
    viettelpay: {
      required: 'viettelpay fee can not be empty',
      type: 'viettelpay fee must be a number',
      min: 'viettelpay fee must be greater than 0',

      max: 'viettelpay fee must be less than or equal to 100',

      float: 'viettelpay fee can have up to two decimal places'
    },
    zalo: {
      required: 'zalo fee can not be empty',
      type: 'zalo fee must be a number',
      min: 'zalo fee must be greater than 0',
      max: 'zalo fee must be less than or equal to 100',
      float: 'zalo fee can have up to two decimal places'
    },
    usdt: {
      required: 'usdt fee can not be empty',
      type: 'usdt fee must be a number',
      min: 'usdt fee must be greater than 0',
      max: 'usdt fee must be less than or equal to 100',
      float: 'usdt fee can have up to two decimal places'
    },
    payoutFixedFee: {
      required: 'Fixed fee payment cannot be empty'
    },
    momoBank: {
      required: 'momoBank personal fee can not be empty',
      type: 'momoBank personal fee must be a number',
      min: 'momoBank personal fee must be greater than 0',
      max: 'momoBank personal fee must be less than or equal to',
      float: 'momoBank personal fee can have up to two decimal places'
    },
    zaloBank: {
      required: 'zaloBank personal fee can not be empty',
      type: 'zaloBank personal fee must be a number',
      min: 'zaloBank personal fee must be greater than 0',
      max: 'zaloBank personal fee must be less than or equal to',
      float: 'zaloBank personal fee can have up to two decimal places'
    },
    vtpBank: {
      required: 'vtpBank personal fee can not be empty',
      type: 'vtpBank personal fee must be a number',
      min: 'vtpBank personal fee must be greater than 0',
      max: 'vtpBank personal fee must be less than or equal to',
      float: 'vtpBank personal fee can have up to two decimal places'
    }
  },
  Minimum_safety_limit_for_merchant_payment: 'Minimum safety limit for merchant payment',
  Please_enter_the_minimum_security_limit_for_merchant_payment:
    'Please enter the minimum security limit for merchant payment',
  Payment_warning_group_id: 'Payment warning group ID',
  Please_enter_the_payment_warning_group_id: 'Please enter the payment warning group ID',
  CannotEmpty: 'Cannot be empty'
};



// WEBPACK FOOTER //
// ./src/i18n/lang/en/clientmanage.js